export const BASE_ANIMATION_SPEED_MS = 300;
export const MIN_ANIMATION_SPEED_MS = 2;
export const COLOR_CHANGE_DURATION_MS = 500;

export const PRIMARY_COLOR = '#244855';
export const COMPARE_COLOR = '#FFB200';
export const SWAP_COLOR = '#874F41';
export const FINAL_COLOR = '#4CAF50';
